import { useContext, useEffect, useState } from "react";
import { MainContext } from "../App";
import Api from "./api/api";
import functions from "../utilities/functions";
import CloseIcon from "../icons/CloseIcon";
import { isTabletEmbed, postToParent } from "../embed";

function Covers() {
	const {
		user,
		setPopupVisible,
		lists,
		settings,
		setLoading,
		setTable,
		setTempTable,
		setFlow,
		tempTable,
		initCart,
		menu,
		shop,
		setTableEditPopup,
		setAlertData,
		ordersDisabled,
		setQrPopupVisible,
		setQrPopupCloseToTables,
	} = useContext(MainContext);
	const [singleOrderMode, setSingleOrderMode] = useState(tempTable.single_order_mode);
	const [selectedCovers, setSelectedCovers] = useState(0);
	const [list, setList] = useState(tempTable.list);
	const [splittedCovers, setSplittedCovers] = useState([]);
	const [loading, setLoadingLocal] = useState(false);

	useEffect(() => {
		setSplittedCovers([]);
	}, [list]);

	const handleClick = (covers) => {
		setSelectedCovers(covers);
	};

	const shouldOpenGeneratedPinQr = () =>
		settings?.mandant?.selfordering == 1 && settings?.selfordering?.pin_mode == "generated";

	const openTableSuccess = (openedTable, products = []) => {
		const mergedTable = {
			...tempTable,
			...openedTable,
			room: openedTable?.room || tempTable?.room || null,
			list:
				openedTable?.list ||
				((openedTable?.list_id ?? tempTable?.list_id) ? tempTable?.list || null : null),
		};

		setLoading(false);
		setPopupVisible(false);
		setTempTable(mergedTable);

		if (!ordersDisabled) {
			initCart(products);
			setFlow(1);
			setTable(mergedTable);
			setTableEditPopup(false);
		} else {
			setTable(false);
			setTableEditPopup(false);
		}

		// embed tablet: il tavolo passa al cliente sul selforder (niente QR del pin generato)
		if (isTabletEmbed) {
			postToParent({ type: "table-open", table_id: mergedTable.id });
			return;
		}

		if (shouldOpenGeneratedPinQr()) {
			setQrPopupCloseToTables(!ordersDisabled);
			setQrPopupVisible(true);
		}
	};

	const handleSubmit = async () => {
		if (list && list.allyoucaneat == 1 && splittedCovers.length == 0) {
			setAlertData({
				title: "Errore",
				message: "Nessun menù selezionato",
				confirmMessage: "Ok",
			});
			return;
		}
		setLoadingLocal(true);
		setLoading(true);
		const response = await Api.postProtected("/tables/edit/" + tempTable.id + "/", {
			status: 1,
			user_id: user.id,
			covers: selectedCovers,
			list_id: list ? list.id : null,
			splitted_covers: getSentSplittedCovers(),
			single_order_mode: singleOrderMode,
		});
		if (response.success == 0) {
			alert(response.error);
			setLoadingLocal(false);
			setLoading(false);
		} else {
			openTableSuccess(response.data, buildCoverProducts());
		}
	};

	const openNewOrder = async () => {
		setLoading(true);
		const response = await Api.postProtected("/tables/edit/" + tempTable.id + "/", {
			status: 1,
			user_id: user.id,
			covers: selectedCovers,
			list_id: list ? list.id : null,
			splitted_covers: getSentSplittedCovers(),
			single_order_mode: singleOrderMode,
		});
		if (response.success == 0) {
			alert(response.error);
			setLoading(false);
		} else {
			openTableSuccess(response.data, buildCoverProducts());
		}
	};

	const incrementSplittedCovers = (id) => {
		const index = splittedCovers.findIndex((el) => el.id == id);
		if (index > -1) {
			const newData = [...splittedCovers];
			newData[index].qty++;
			setSplittedCovers(newData);
		} else {
			setSplittedCovers([...splittedCovers, { id: id, qty: 1 }]);
		}
	};

	const decrementSplittedCovers = (id) => {
		const index = splittedCovers.findIndex((el) => el.id == id);
		if (index > -1) {
			if (splittedCovers[index].qty == 0) return;
			const newData = [...splittedCovers];
			newData[index].qty--;
			setSplittedCovers(newData);
		} else {
			setSplittedCovers([...splittedCovers, { id: id, qty: 1 }]);
		}
	};

	const getSplittedCovers = (id) => {
		const el = splittedCovers.find((el) => el.id == id);
		if (el) return el.qty;
		else return 0;
	};

	const getFilteredProducts = (filter) => {
		const res = [];
		for (const course of menu) {
			for (const category of course.categories) {
				for (const product of category.products) {
					if (product[filter] == 1) {
						if (list) {
							const priceList = product.prices.find(
								(p) => p.list_id == list.id && p.price
							);
							const assortment = product.assortment.find(
								(el) =>
									el.shop_id == shop.id && el.list_id == list.id && el.active == 1
							);
							//console.log("priceList", priceList);
							if (priceList && assortment)
								res.push({ ...product, price: priceList.price });
						} else res.push(product);
					}
				}
			}
		}
		//console.log("getFilteredProducts", filter, res);
		return res;
	};

	const findProduct = (field, value) => {
		for (const course of menu) {
			for (const category of course.categories) {
				for (const product of category.products) {
					if (product[field] == value) {
						if (list) {
							const priceList = product.prices.find(
								(p) => p.list_id == list.id && p.price
							);
							if (priceList) return { ...product, price: priceList.price };
						} else return product;
					}
				}
			}
		}
	};

	// prodotti menu/scelta rapida da inviare all'apertura (senza le voci azzerate col -)
	const getSentSplittedCovers = () => {
		const sent = splittedCovers.filter((el) => el.qty > 0);
		return sent.length > 0 ? sent : null;
	};

	const buildCoverProducts = () => {
		const products = [];
		// con splitted_covers (menu/scelta rapida) coperto e servizio li aggiunge già il server
		// nell'ordine di apertura (tables.php::generate_selforder_menu_order): non vanno nel carrello
		if (singleOrderMode == 0 && settings.orders.generate_covers_order == 0 && !getSentSplittedCovers()) {
			if (!list || list.allyoucaneat != 1) {
				if (selectedCovers > 0) {
					const coverProduct = findProduct("is_cover", 1);
					if (coverProduct) products.push({ ...coverProduct, qty: selectedCovers, flow: 1 });
				}
				const serviceProduct = findProduct("is_service", 1);
				if (serviceProduct) products.push({ ...serviceProduct, qty: 1, flow: 1 });
			}
		}
		return products;
	};

	return (
		<div className="popup md table-edit-popup covers-popup">
				<div className="container covers-table table-edit-container">
					<header>
						<div className="buttons-group">
							<div>
								<span>Apertura</span>
								<div className="name-open-table">
									{tempTable.name}{" "}
									<span className="extrasmall">{tempTable.room?.name || ""}</span>
								</div>
							</div>
						</div>
						<div className="buttons-group">
							<button
								className="btn btn-tertiary btn-square"
								onClick={() => setPopupVisible(false)}
							>
								<CloseIcon />
							</button>
						</div>
					</header>
				<div className="content table-edit-content">
					<div className="boxed-section list-selector-section">
						<div className="list-selector-head">
							<div className="list-selector-title">Listino</div>
							<div className="list-selector-help">Scegli quello da applicare al tavolo</div>
						</div>
						<div className="lists-container list-selector-grid">
							{settings.waiter_app.hide_base_list != 1 && (
								<button
									className={
										"btn list-selector-option" +
										(!list ? " btn-secondary selected" : " btn-tertiary")
									}
									onClick={() => setList(null)}
								>
									Base
								</button>
							)}
							{lists.map((l, i) => (
								<button
									key={i}
									className={
										"btn list-selector-option" +
										(list && l.id == list.id
											? " btn-secondary selected"
											: " btn-tertiary")
									}
									onClick={() => setList(l)}
								>
									{l.name}
								</button>
							))}
						</div>
					</div>

					{!isTabletEmbed && (!list || list.allyoucaneat == 0) && (
						<div className="boxed-section">
							<div className="single-order-toggle-row">
								<div className="single-order-toggle-label">Ordine singolo</div>
								<div className="single-order-toggle-control">
									<label className="single-order-toggle">
										<input
											type="checkbox"
											checked={parseInt(singleOrderMode) === 1}
											onChange={(e) => setSingleOrderMode(e.target.checked ? 1 : 0)}
										/>
										<span className="single-order-toggle-slider"></span>
									</label>
								</div>
							</div>
						</div>
					)}

					{(!list || list.allyoucaneat == 0) && (
						<div className="boxed-section">
							<div className="covers-count-row">
								<div className="covers-count-text">
									<div className="covers-count-title">Coperti</div>
									<div className="covers-count-help">Scegli il numero di coperti</div>
								</div>
								<div className="plus-minus covers-count-control">
									<button
										onClick={() =>
											handleClick(selectedCovers > 0 ? selectedCovers - 1 : 0)
										}
									>
										&#8722;
									</button>
									<input
										type="number"
										value={selectedCovers}
										onChange={(event) => handleClick(parseInt(event.target.value))}
									/>
									<button onClick={() => handleClick(selectedCovers + 1)}>
										&#43;
									</button>
								</div>
							</div>
						</div>
					)}
					{list && list.allyoucaneat == 1 && (
						<div className="boxed-section">
							<div className="group vertical">
								<p className="text-desc">Scegli i menu:</p>
								{getFilteredProducts("is_selfordering_menu").map((product, i) => (
									<div key={i} className="product-line menu-choice-line">
										<div className="menu-choice-info">
											<div className="menu-choice-name">{product.name}</div>
											<div className="menu-choice-price">
												{functions.formatter.format(product.price)}
											</div>
										</div>
										<div className="plus_minus_container menu-choice-controls">
											<button
												className="btn btn-primary btn-square"
												onClick={() => decrementSplittedCovers(product.id)}
											>
												&#8722;
											</button>
											<div>{getSplittedCovers(product.id)}</div>
											<button
												className="btn btn-primary btn-square"
												onClick={() => incrementSplittedCovers(product.id)}
											>
												+
											</button>
										</div>
									</div>
								))}
							</div>
						</div>
					)}
					{settings.orders.tables_open_by_filled != 1 &&
						getFilteredProducts("rapid_choice").length > 0 && (
							<div className="boxed-section">
								<div className="group vertical">
									<p className="text-desc">
										Scelta rapida prodotti:
										<span className="text-desc-small">
											Aggiungi in apertura del tavolo i seguenti prodotti:
										</span>
									</p>
									{getFilteredProducts("rapid_choice").map((product, i) => (
										<div key={i} className="product-line rapid-choice-line">
											<div className="rapid-choice-info">
												<div className="rapid-choice-name">{product.name}</div>
												<div className="rapid-choice-price">
													{functions.formatter.format(product.price)}
												</div>
											</div>
											<div className="plus_minus_container rapid-choice-controls">
												<button
													className="btn btn-primary btn-square"
													onClick={() =>
														decrementSplittedCovers(product.id)
													}
												>
													-
												</button>
												<div>{getSplittedCovers(product.id)}</div>
												<button
													className="btn btn-primary btn-square"
													onClick={() =>
														incrementSplittedCovers(product.id)
													}
												>
													+
												</button>
											</div>
										</div>
									))}
								</div>
							</div>
						)}
				</div>
				<div className="table-actions table-edit-actions">
					{settings.orders.tables_open_by_filled == 1 ? (
						<button
							className="btn btn-primary btn-block table-action-full table-action-new-order"
							onClick={openNewOrder}
						>
							Nuova comanda
						</button>
					) : (
						<button className="btn btn-primary btn-block table-action-full" onClick={handleSubmit} disabled={loading}>
							Apri Tavolo
						</button>
					)}
				</div>
			</div>
		</div>
	);
}

export default Covers;
